<template>
  <div>
    <h1>Not Found</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView',

  props: {},

  data () {
    return {
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
